import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { masterRentalConfig } from "@/lib/datasetRegistry"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `masterRentalConfig` (app/frontend/lib/datasetRegistry.ts). Controller
// renders this via inertia page name "admin/master_rental/Uploads".
export default function AdminMasterRentalUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={masterRentalConfig} {...props} />
}
